import {
  IsUUID,
  IsOptional,
  IsDateString,
  IsInt,
  IsBoolean,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

/**
 * DTO pour une assignation d'activité à un enseignement/classe
 */
export class ActivityTeachingAssignmentDto {
  @ApiProperty({
    description: 'ID de la classe/enseignement cible',
    format: 'uuid',
  })
  @IsUUID()
  teachingId!: string

  @ApiPropertyOptional({
    description: 'Date de disponibilité (ISO 8601)',
    example: '2024-11-01T00:00:00Z',
  })
  @IsOptional()
  @IsDateString()
  availableFrom?: string

  @ApiPropertyOptional({
    description: "Date d'échéance (ISO 8601)",
    example: '2024-11-30T23:59:59Z',
  })
  @IsOptional()
  @IsDateString()
  dueAt?: string

  @ApiPropertyOptional({
    description: 'Nombre maximum de tentatives',
    example: 3,
  })
  @IsOptional()
  @IsInt()
  maxAttempts?: number

  @ApiPropertyOptional({
    description: 'Afficher les solutions après soumission',
    default: false,
  })
  @IsOptional()
  @IsBoolean()
  showSolutions?: boolean

  @ApiPropertyOptional({
    description: "Randomiser l'ordre des questions",
    default: false,
  })
  @IsOptional()
  @IsBoolean()
  randomizeOrder?: boolean
}
